// The context feature: the workspace and project selector, the environment switch, the `/`
// redirect and the paths module every registry screen builds its links with.
import { registerTopBarSlot } from "../../app/registry/slots";
import { ContextSelector } from "./context-selector";
import { EnvSwitch } from "./env-switch";

registerTopBarSlot("context", ContextSelector);
registerTopBarSlot("environment", EnvSwitch);

export {
  type ChatSearch,
  type EnvironmentsSearch,
  type RunsSearch,
  routes,
  type SpecSearch,
  type SpecsSearch,
  type SpecTab,
  specTabs,
  type UsersSearch,
} from "./paths";
export { byTier, useCosmosContext, useEnvironment, useReadOnly } from "./use-context";
export { useServerUrl, WorkspaceLayout, WorkspaceRedirect } from "./workspace-pages";
